import { combineReducers } from 'redux'
import documentDataReducer  from './duck/document'
import globalDataReducer  from './duck/global'

const rootReducer = combineReducers({
  documentData: documentDataReducer,
  globalData: globalDataReducer
})

export default rootReducer
